// FlagContext.js
import React, { createContext, useEffect, useState } from "react";

const initialFlagState = {
  Properties: {},
  isDesignSaving: false,
  isDesignSave: false,
  DXFSnaps: null,
  isDesign: false,
  cursor: false,
  Data2D: [],
  Data3D: [],
  PrevData3D : [],
  isSelected: false,
  isSelectedType: '',
  DXFMode: "",
  isDXFEdit: false,
  rotationProp: {},
  ThreeDProp: {},
  ThreeWayRule: {},
  ExpandProperties: false,
  snaps: {},
  DoorProperties: {
    "Door Height": "2400",
    Glass: "10mm Toughend Glass",
    // "Stile frame" : "Single - 82x40[13]",
    Finish: "#1a1a1a",
    Orientation: "Left",
    Opening: "Push",

    "Door Handle": "",
    "Door Lock": "",
    "Door closer": "",
    "Drop Down Seal": {make: null ,description: 'Drop Down Seal', enabled: false },
    "Door Stopper": {make: null ,description: 'Door Stopper', enabled: false },
    "Tower Bolt": {make: null, description: 'Tower Bolt', enabled: false },
  },
  PartitionProperties: {
    "Partition Height": "2400",
    "Profile Finish": "#1a1a1a",
    "Glass Thickness": "10mm",
    "Glass Type": "Toughened Glass",
    Acoustic: "10mm",
    "Glass Joint": "Two-way Polycarbonate",
    "Gasket Color": "Default Black",
  },
  TwoD: {
    system_id: "",
    product_id: "",
    division: "", // sytems
    mode: "", // partition or Door
    type: "", // type of template
    divisionIndex: "",
    modeIndex: "",
    typeIndex: "",
    gridVisible: true, // to show grid / white
    unit: "mm", // switch btw inchen and mm
    history: [], // to store redo/undo
    redoStack: [], // Clear redo stack after a new action
    isUndoDisabled: true,
    isRedoDisabled: true,
    portal: {},
  },
  Rules: {},
  design_type: "",
  boxPositions: [],
  selectedBgColor: "#212830"
};

export const FlagContext = createContext();
const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const FlagProvider = ({ children }) => {
  const [flag, setFlag] = useState(initialFlagState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // const updateFlag = (key, value, replace = false) => {
  //   setFlag((prevFlag) => ({
  //     ...prevFlag,
  //     [key]: replace
  //       ? value // Replace the object completely
  //       : typeof prevFlag[key] === 'object' && !Array.isArray(prevFlag[key])
  //       ? { ...prevFlag[key], ...value } // Merge the object if it's not being replaced
  //       : value, // Replace if it's an array or primitive
  //   }));
  // };

  const fetchTemplateAttributes = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/templatecomponentattributes/attributes/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      if (data.status === "success") {
        const dataFromDB = data;
        dataFromDB.data.sort((a, b) => {
          return (
            orderedTemplates.indexOf(a.template_name) -
            orderedTemplates.indexOf(b.template_name)
          );
        });
        const tranformData = await transformInputToOutput(data);

        console.log("Properties", tranformData);
        const FinalJson = await reorderAttributes(tranformData);

        console.log("Properties2", FinalJson);

        updateFlag("Properties", FinalJson, true);
        //resetFlag(properties);
      } else {
        setError("Failed to retrieve Attributes.");
      }
    } catch (err) {
      setError("An error occurred while fetching Attributes.");
    } finally {
      setLoading(false);
    }
  };

  async function transformInputToOutput(inputJson) {
    const output = { systems: [] };

    if (!inputJson || !inputJson.data || !Array.isArray(inputJson.data)) {
      return output;
    }

    const systemMap = new Map();
    inputJson.data.forEach((template) => {
      const systemName = template.assigned_values[0].system_name || "Unknown";
      const productName = template.assigned_values[0].product_name || "Unknown";
      const systemId = template.assigned_values[0].system_id || "Unknown";
      const productId = template.assigned_values[0].product_id || "Unknown";

      // Check if system already exists, otherwise create new system object
      if (!systemMap.has(systemName)) {
        const newSystem = {
          system_id: systemId, // Assume a function to generate a unique ID
          system_name: systemName,
          products: [],
        };
        systemMap.set(systemName, newSystem);
        output.systems.push(newSystem);
      }

      const system = systemMap.get(systemName);

      // Check if product already exists within the system
      let product = system.products.find((p) => p.product_name === productName);
      if (!product) {
        product = {
          product_id: productId, // Assume a function to generate a unique ID
          product_name: productName,
          templates: [],
        };
        system.products.push(product);
      }

      // Add template and map assigned values to attributes
      const newTemplate = {
        template_id: template.template_id,
        template_name: template.template_name,
        template_img_url: null, // Placeholder, add if URL available
        attributes: [],
      };

      // Group assigned values by component_attribute_name
      const attributeMap = new Map();
      template.assigned_values.forEach((value) => {
        const attrName = value.component_attribute_name;
        if (!attributeMap.has(attrName)) {
          attributeMap.set(attrName, {
            component_attribute_id: value.component_attribute_id,
            component_attribute_name: attrName,
            component_id: value.component_id,
            component_name: value.component_name, // Assume a function for missing names
            component_type: value.component_type,
            values: [],
          });
        }

        // Add values within each attribute
        const attribute = attributeMap.get(attrName);
        attribute.values.push({
          comp_attribute_value_id: value.comp_attribute_value_id,
          comp_attribute_value_name: value.comp_attribute_value_name,
          comp_attribute_value: String(value.comp_attribute_value_id),
          isDefault: value.isdefault,
        });
      });

      // Add mapped attributes to template
      newTemplate.attributes = Array.from(attributeMap.values());
      product.templates.push(newTemplate);
    });
    return output;
  }

  function reorderAttributes(json) {
    json.systems.forEach((system) => {
      system.products.forEach((product) => {
        product.templates.forEach((template) => {
          // Sort attributes based on the provided order
          let ORDER;
          if (
            template.template_name === "Fixed Partition" ||
            template.template_name === "Partition with Jcap" ||
            template.template_name === "Partition with stick-on profile"
          )
            ORDER = orderP;
          else if (
            template.template_name === "Stile Door - Single leaf" ||
            template.template_name === "Sliding Door" ||
            template.template_name === "Stile Door - Overhead Panel"
          )
            ORDER = orderD;

          if (ORDER) {
            template.attributes.sort((a, b) => {
              const indexA = ORDER.indexOf(a.component_attribute_name);
              const indexB = ORDER.indexOf(b.component_attribute_name);

              // If not found in order list, move to the end
              if (indexA === -1 && indexB === -1) return 0;
              if (indexA === -1) return 1;
              if (indexB === -1) return -1;

              return indexA - indexB;
            });
          }
        });

        if (product.product_name === "Partition") {
          /* product.templates[1] = {
                    "template_id": 12,
                    "template_name": "Partition with Jcap",
                    "template_img_url": null,
                    "attributes": []
                }
                product.templates[2] = {
                    "template_id": 13,
                    "template_name": "Partition with stick-on profile",
                    "template_img_url": null,
                    "attributes": []
                }*/
        }
        if (product.product_name === "Door") {
          /*product.templates[1] = {
                    "template_id": 11,
                    "template_name": "Sliding Door",
                    "template_img_url": null,
                    "attributes": []
                }
                product.templates[2] = {
                    "template_id": 11,
                    "template_name": "Patch Fitting Door",
                    "template_img_url": null,
                    "attributes": []
                }*/
        }
      });
    });
    json.systems[1] = {
      system_id: 18,
      system_name: "Octa",
      products: [],
    };
    json.systems[2] = {
      system_id: 6,
      system_name: "Hexa",
      products: [],
    };
    json.systems[3] = {
      system_id: 4,
      system_name: "Influence",
      products: [],
    };
    return json;
  }

  const orderP = [
    "Partition Height",
    "Profile Finish",
    "Glass Type",
    "Glass Thickness",
    "Acoustic Value",
    "Glass Joint",
    "Gasket Color",
    "Jcap size",
    "Jcap Side",
  ];
  const orderD = [
    "Door Height",
    "Glass",
    "Overhead Panel Height",
    "Profile Finish",
    "Hardware Finish",
    "Movable",
    "Sliding Door Placement",
    "Orientation",
    "Opening",
    "Glass Type",
    "Glass Thickness",
    "Acoustic Value",
    "Stile Door Frame",
    "Door Handle",
    "Door Lock",
    "Door Closer",
    "Gasket Color",
    "Door Stopper",
    "Tower Bolt",
    "Offset Handle",
    "Dead Lock",
    "Bottom Track",
  ];
  // Ensure templates are displayed in correct order
  const orderedTemplates = [
    "Fixed Partition",
    "Partition with Jcap",
    "Partition with stick-on profile",
    "Stile Door - Single leaf",
    "Sliding Door",
    "Stile Door - Overhead Panel",
  ];

  useEffect(() => {
    fetchTemplateAttributes();
  }, []);

  useEffect(() => {
    // console.log(flag);
  }, [flag]);

  function isRealObject(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
  }

  const updateFlag = (keyOrUpdates, value, replace = false) => {
    // If keyOrUpdates is an object, it means multiple keys are being updated at once
    if (isRealObject(keyOrUpdates)) {
      setFlag((prevFlag) => ({
        ...prevFlag,
        ...Object.keys(keyOrUpdates).reduce((acc, key) => {
          acc[key] = isRealObject(prevFlag[key])
            ? { ...prevFlag[key], ...keyOrUpdates[key] }
            : keyOrUpdates[key];
          return acc;
        }, {}),
      }));
    } else {
      // Update a single key (either replace or merge based on `replace` flag)
      setFlag((prevFlag) => ({
        ...prevFlag,
        [keyOrUpdates]: replace
          ? value // Replace the object completely
          : isRealObject(prevFlag[keyOrUpdates])
          ? { ...prevFlag[keyOrUpdates], ...value } // Merge the object if it's not being replaced
          : value, // Replace if it's an array or primitive
      }));
    }
  };

  // updateFlag("Data2D", []); // Clear Data2D and merge updates
  // updateFlag("TwoD", { mode: "mode", type: "type" }); // Merge mode and type into TwoD
  // updateFlag("TwoD", { mode: "newMode" }, true); // Replace TwoD completely if replace=true
  // updateFlag({
  //   Data2D: [], // Clear Data2D
  //   TwoD: { mode: line.mode, type: line.type }, // Update TwoD with mode and type
  // });
  // resetFlag("TwoD") // to reset to default

  const resetFlag = (key) => {
    setFlag((prevFlag) => ({
      ...prevFlag,
      [key]: initialFlagState[key], // Reset the key to its default value
    }));
  };

  return (
    <FlagContext.Provider value={{ flag, updateFlag, resetFlag }}>
      {children}
    </FlagContext.Provider>
  );
};

export default FlagContext;
